import { Box, Input, StyledBox, theme } from '@components/gassan-ui'
import { Text } from '@components/gassan-ui/Typography/Text'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

type Props = {
  handleChange: (value: number) => void
  value: number
}

const EnterAmount: FC<Props> = ({ value, handleChange }) => {
  const { t } = useTranslation('other')
  return (
    <>
      <Box width="100%">
        <StyledBox className="mb-2 pb-2">
          <Text variant="regular" className={cn('mb-1', 'md:mb-2', 'lg:mb-3')} as="div">
            {t('enterGiftcardAmount')}
          </Text>
          <Text variant="small" className={cn('mb-0', 'text-shade-500')} as="div">
            {t('giftcardMinMax')}
          </Text>
        </StyledBox>
        <Box pb="16px" borderBottom={`1px solid ${theme.colors.shades[200]}`}>
          <Input
            className={cn('pb-2 pt-2', 'focus:pb-2 focus:pt-2', 'filled:pt-2 filled:pb-2')}
            type="number"
            placeholder="Enter value"
            data-test-id="enter-giftcard-amount"
            value={value.toString()}
            onChange={(event) => onInputChange(event.target.value)}
          />
        </Box>
      </Box>
    </>
  )

  function onInputChange(val: string) {
    const parsedInteger = parseInt(val, 10)
    if (!parsedInteger || parsedInteger < 0) {
      handleChange(0)
    } else {
      handleChange(parsedInteger)
    }
  }
}

export default EnterAmount
